/**
 * JSON-LD Script Component
 * Renders structured data for SEO
 */

/**
 * JSON-LDを `<script>` タグへ `dangerouslySetInnerHTML` で埋め込む際の
 * 安全な文字列化。`JSON.stringify` の結果に含まれ得る `</script>` を
 * そのまま埋め込むと、動的な値（URLパラメータ由来の値など）を通じて
 * スクリプトタグを早期終了させる反射型XSSにつながるため、
 * `<` を `<` にエスケープして無害化する。
 * あわせてJavaScript構文エラーの原因になるU+2028/U+2029もエスケープする。
 */
const LS = String.fromCharCode(0x2028);
const PS = String.fromCharCode(0x2029);
const LS_PS_PATTERN = new RegExp(`[${LS}${PS}]`, "g");

function safeJsonLdStringify(data: unknown): string {
  return (JSON.stringify(data) ?? "null")
    .replace(/</g, "\\u003c")
    .replace(LS_PS_PATTERN, (char) => (char === LS ? "\\u2028" : "\\u2029"));
}

export function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLdStringify(data) }}
    />
  );
}

export default JsonLd;
